/* CSL · Landing pages: LED background, reveal on scroll, countdown, product filters and the enclosed cart drawer.
   One deferred file, no dependencies. The cart uses the Shopify Ajax Cart API + Section Rendering API
   (section "csl-lp-cart"), so prices, discounts and stock always come from Shopify. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px' })
    : null;
  const initReveal = (scope = document) => $$('.lp-rv, .lp-split', scope).forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));

  /* ---------- Countdown (dates from the hero section) ---------- */
  const two = (n) => String(n).padStart(2, '0');
  let cdTimer = 0;
  const initCountdown = () => {
    clearInterval(cdTimer);
    const src = $('[data-lp-campaign]');
    if (!src) return;
    const start = Date.parse(src.dataset.start), end = Date.parse(src.dataset.end);
    if (Number.isNaN(end)) return;
    const L = { before: src.dataset.labelBefore, during: src.dataset.labelDuring, after: src.dataset.labelAfter, d: src.dataset.unitD, h: src.dataset.unitH, m: src.dataset.unitM };
    const tick = () => {
      const now = Date.now();
      const before = !Number.isNaN(start) && now < start;
      const target = before ? start : end;
      if (!before && document.documentElement.classList.contains('lp-pre')) { clearInterval(cdTimer); location.reload(); return; }   // teaser over: load the full page
      const label = before ? L.before : (now <= end ? L.during : L.after);
      let s = Math.max(0, Math.floor((target - now) / 1000));
      const d = Math.floor(s / 86400); s -= d * 86400;
      const h = Math.floor(s / 3600); s -= h * 3600;
      const m = Math.floor(s / 60); s -= m * 60;
      $$('[data-lp-cd-label]').forEach((el) => { el.textContent = label; });
      $$('[data-lp-cd="d"]').forEach((el) => { el.textContent = two(d); });
      $$('[data-lp-cd="h"]').forEach((el) => { el.textContent = two(h); });
      $$('[data-lp-cd="m"]').forEach((el) => { el.textContent = two(m); });
      $$('[data-lp-cd="s"]').forEach((el) => { el.textContent = two(s); });
      $$('[data-lp-cd-text]').forEach((el) => { el.textContent = now > end ? label : `${label} ${d} ${L.d} · ${h} ${L.h} · ${m} ${L.m}`; });
    };
    tick();
    cdTimer = setInterval(tick, 1000);
  };

  /* ---------- Product filters ---------- */
  const applyFilter = (sec, value) => {
    $$('[data-lp-filter]', sec).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.lpFilter === value)));
    $$('[data-lp-item]', sec).forEach((li) => {
      const tags = ` ${li.dataset.filters || ''} `;
      li.hidden = value === 'all' ? li.dataset.hideAll === 'true' : !tags.includes(` ${value} `);
    });
  };
  const initFilters = (scope = document) => $$('[data-lp-products]', scope).forEach((sec) => {
    const first = $('[data-lp-filter]', sec);
    if (first) applyFilter(sec, first.dataset.lpFilter);
  });
  const gotoCollection = (handle) => {
    const tab = $$('[data-lp-filter][data-collections]').find((b) => ` ${b.dataset.collections} `.includes(` ${handle} `));
    if (!tab) {   // no filters on the page: just take the visitor to the products, without leaving the landing
      const sec = $('[data-lp-products]');
      if (!sec) return false;
      sec.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
      return true;
    }
    const sec = tab.closest('[data-lp-products]');
    applyFilter(sec, tab.dataset.lpFilter);
    sec.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
    return true;
  };

  /* ---------- Cart drawer ---------- */
  const cartSec = () => $('[data-lp-cart]');
  let lastFocus = null;
  const openCart = () => {
    const d = $('[data-lp-drawer]');
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    const bar = $('[data-lp-bar]');
    if (bar) bar.classList.remove('is-shown');
    setTimeout(() => { const c = $('.lp-close', d); if (c) c.focus(); }, 60);
  };
  const closeCart = () => {
    const d = $('[data-lp-drawer]');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    const sec = cartSec(), bar = $('[data-lp-bar]');
    if (bar && sec && Number(sec.dataset.count) > 0) bar.classList.add('is-shown');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  const setCount = (count, flash) => {
    $$('[data-lp-count]').forEach((el) => { el.textContent = count; });
    $$('[data-lp-led]').forEach((l) => {
      l.classList.toggle('is-on', count > 0);
      if (flash && count > 0) { l.classList.remove('is-flash'); void l.offsetWidth; l.classList.add('is-flash'); }
    });
  };
  const renderCart = (html, flash) => {
    const sec = cartSec();
    if (!sec || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-lp-cart]');
    if (!fresh) return;
    sec.dataset.count = fresh.dataset.count;
    ['[data-lp-cart-content]', '[data-lp-bar]'].forEach((sel) => {
      const a = $(sel, sec), b = $(sel, fresh);
      if (a && b) a.replaceWith(b);
    });
    const open = $('[data-lp-drawer]', sec).classList.contains('is-open');
    const bar = $('[data-lp-bar]', sec);
    if (bar) bar.classList.toggle('is-shown', Number(fresh.dataset.count) > 0 && !open);
    setCount(Number(fresh.dataset.count), flash);
  };
  const cartRequest = async (path, body) => {
    const sec = cartSec();
    const payload = { ...body };
    if (sec) { payload.sections = [sec.dataset.sectionId]; payload.sections_url = location.pathname; }
    const r = await fetch(`${root}${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'Eroare');
    return data;
  };
  const showError = (msg) => {
    const box = $('[data-lp-cart-error]');
    if (box) { box.textContent = msg; box.hidden = false; }
  };
  const addItems = async (items, btn) => {
    if (btn && btn.getAttribute('aria-busy') === 'true') return; // already adding: ignore double clicks
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    const started = Date.now();
    try {
      const data = await cartRequest('cart/add.js', { items });
      const sec = cartSec();
      if (sec && data.sections) renderCart(data.sections[sec.dataset.sectionId], true);
      openCart();
    } catch (e) {
      openCart();
      showError(e.message);
    } finally {
      // keep the spinner visible for a moment even on a fast connection
      const wait = Math.max(0, 450 - (Date.now() - started));
      setTimeout(() => { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } }, wait);
    }
  };
  const changeLine = async (key, quantity) => {
    try {
      const data = await cartRequest('cart/change.js', { id: key, quantity });
      const sec = cartSec();
      if (sec && data.sections) renderCart(data.sections[sec.dataset.sectionId], false);
    } catch (e) { showError(e.message); }
  };

  /* ---------- Events ---------- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-lp-add]');
    if (!form || !cartSec()) return; // without the cart section the form posts normally to /cart/add
    e.preventDefault();
    let items;
    try { items = form.dataset.items ? JSON.parse(form.dataset.items) : null; } catch (err) { items = null; }
    if (!items) items = [{ id: Number(new FormData(form).get('id')), quantity: 1 }];
    addItems(items, form.querySelector('[type="submit"]'));
  });
  document.addEventListener('click', (e) => {
    const t = e.target.closest('button, a');
    if (!t) return;
    if (t.matches('[data-lp-top]')) {
      e.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    }
    else if (t.matches('[data-lp-open]')) { e.preventDefault(); openCart(); }
    else if (t.matches('[data-lp-close]')) { e.preventDefault(); closeCart(); }
    else if (t.matches('[data-lp-change]')) { e.preventDefault(); changeLine(t.dataset.key, Number(t.dataset.qty)); }
    else if (t.matches('[data-lp-filter]')) applyFilter(t.closest('[data-lp-products]'), t.dataset.lpFilter);
    else if (t.matches('[data-lp-goto]')) { if (gotoCollection(t.dataset.lpGoto)) e.preventDefault(); }
  });
  document.addEventListener('keydown', (e) => {
    const d = $('[data-lp-drawer].is-open');
    if (e.key === 'Escape' && d) closeCart();
  });

  /* ---------- LED field ---------- */
  const leds = (() => {
    const cv = $('[data-lp-leds]');
    if (!cv || !cv.getContext) return null;
    const ctx = cv.getContext('2d');
    let cfg = { enabled: true, min: 10, max: 80, glow: 55 };
    const S = 48, sprite = document.createElement('canvas');
    sprite.width = sprite.height = S;
    const sg = sprite.getContext('2d');
    let RGB = [255, 42, 61];                      // LED colour (campaign colour from the hero, default red)
    const paintSprite = () => {
      const [r, g0, b] = RGB, mix = (c, t) => Math.round(c + (255 - c) * t);
      const g = sg.createRadialGradient(S / 2, S / 2, 0, S / 2, S / 2, S / 2);
      g.addColorStop(0, `rgba(${mix(r, .9)},${mix(g0, .9)},${mix(b, .9)},1)`);
      g.addColorStop(0.09, `rgba(${mix(r, .1)},${mix(g0, .1)},${mix(b, .1)},.95)`);
      g.addColorStop(0.26, `rgba(${r},${g0},${b},.38)`);
      g.addColorStop(0.55, `rgba(${r},${g0},${b},.08)`);
      g.addColorStop(1, `rgba(${r},${g0},${b},0)`);
      sg.clearRect(0, 0, S, S);
      sg.fillStyle = g;
      sg.fillRect(0, 0, S, S);
    };
    paintSprite();

    const P = new Uint8Array(512);
    { const p = [...Array(256).keys()]; for (let i = 255; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [p[i], p[j]] = [p[j], p[i]]; } for (let i = 0; i < 512; i++) P[i] = p[i & 255]; }
    const fade = (t) => t * t * (3 - 2 * t), lerp = (a, b, t) => a + (b - a) * t;
    const hash = (x, y, z) => P[(P[(P[x & 255] + y) & 255] + z) & 255] / 255;
    const noise = (x, y, z) => {
      const xi = Math.floor(x), yi = Math.floor(y), zi = Math.floor(z);
      const xf = fade(x - xi), yf = fade(y - yi), zf = fade(z - zi);
      const c = (a, b, d) => hash(xi + a, yi + b, zi + d);
      return lerp(lerp(lerp(c(0, 0, 0), c(1, 0, 0), xf), lerp(c(0, 1, 0), c(1, 1, 0), xf), yf),
        lerp(lerp(c(0, 0, 1), c(1, 0, 1), xf), lerp(c(0, 1, 1), c(1, 1, 1), xf), yf), zf);
    };
    let W = 0, H = 0, gap = 20, dots = [], vals = new Float32Array(0), alpha = new Float32Array(0);
    let sTarget = scrollY, sCur = scrollY, lastSc = scrollY, intro = 0, phase = 0, zphase = 0, vel = 0, settle = 1, lastT = 0, raf = 0, still = 0;
    // Performance: 30 fps on phones, weaker devices and data saver (the drift is slow, it looks the same)
    const lowPower = innerWidth < 700 || (navigator.hardwareConcurrency || 8) <= 4 || (navigator.connection && navigator.connection.saveData);
    const minStep = lowPower ? 32 : 0;
    const ease = (k, dt) => 1 - Math.pow(1 - k, dt);   // per-frame smoothing that stays the same at any frame rate
    const hist = new Uint32Array(128);

    /* Spooky shapes (Halloween only, hero setting „Forme LED”): now and then the lit LEDs gather into a soft,
       semi-abstract silhouette (pumpkin, bat, ghost), hold it for a few seconds and dissolve back into the drift. */
    const SHAPES = {
      pumpkin(c) {
        c.beginPath(); c.ellipse(-22, 4, 30, 36, 0, 0, 7); c.ellipse(22, 4, 30, 36, 0, 0, 7); c.ellipse(0, 2, 32, 40, 0, 0, 7); c.fill();
        c.fillRect(-5, -46, 10, 14);
        c.globalCompositeOperation = 'destination-out';
        c.beginPath(); c.moveTo(-28, -2); c.lineTo(-10, -2); c.lineTo(-19, -18); c.closePath(); c.fill();
        c.beginPath(); c.moveTo(28, -2); c.lineTo(10, -2); c.lineTo(19, -18); c.closePath(); c.fill();
        c.beginPath(); c.moveTo(-26, 14); c.lineTo(-16, 22); c.lineTo(-8, 15); c.lineTo(0, 23); c.lineTo(8, 15); c.lineTo(16, 22); c.lineTo(26, 14); c.lineTo(20, 30); c.lineTo(-20, 30); c.closePath(); c.fill();
        c.globalCompositeOperation = 'source-over';
      },
      bat(c) {
        const half = [[0, -8], [-10, -12], [-30, -26], [-60, -18], [-52, -4], [-42, -8], [-36, 6], [-26, 0], [-18, 14], [-8, 8], [0, 16]];
        c.beginPath(); half.forEach(([x, y], i) => (i ? c.lineTo(x, y) : c.moveTo(x, y))); [...half].reverse().forEach(([x, y]) => c.lineTo(-x, y)); c.closePath(); c.fill();
        c.beginPath(); c.moveTo(-8, -8); c.lineTo(-6, -22); c.lineTo(-2, -10); c.lineTo(2, -10); c.lineTo(6, -22); c.lineTo(8, -8); c.closePath(); c.fill();
      },
      ghost(c) {
        c.beginPath(); c.moveTo(-32, 40); c.lineTo(-32, -8); c.arc(0, -8, 32, Math.PI, 0); c.lineTo(32, 40);
        c.quadraticCurveTo(26, 30, 21, 40); c.quadraticCurveTo(16, 30, 11, 40); c.quadraticCurveTo(5, 30, 0, 40); c.quadraticCurveTo(-5, 30, -11, 40); c.quadraticCurveTo(-16, 30, -21, 40); c.quadraticCurveTo(-26, 30, -32, 40); c.fill();
        c.globalCompositeOperation = 'destination-out';
        c.beginPath(); c.ellipse(-12, -10, 6, 9, 0, 0, 7); c.ellipse(12, -10, 6, 9, 0, 0, 7); c.fill();
        c.beginPath(); c.ellipse(0, 10, 5, 7, 0, 0, 7); c.fill();
        c.globalCompositeOperation = 'source-over';
      },
    };
    const SHAPE_ORDER = ['pumpkin', 'bat', 'ghost'];
    let shape = null, shapeN = 0, nextShapeAt = 0;
    const makeShape = (name) => {
      const k = 8, sw = Math.ceil(W / k), sh = Math.ceil(H / k);
      const oc = document.createElement('canvas'); oc.width = sw; oc.height = sh;
      const c = oc.getContext('2d');
      const size = Math.min(sw, sh) * (W < 700 ? 0.72 : 0.6);
      const cx = sw * (W < 700 ? 0.5 : 0.55 + Math.random() * 0.25), cy = sh * (0.3 + Math.random() * 0.25);
      c.filter = `blur(${Math.max(1, size * 0.03).toFixed(1)}px)`;          // soft edges: guessed, not drawn
      c.fillStyle = '#fff';
      c.translate(cx, cy); c.rotate((Math.random() - 0.5) * 0.3); c.scale(size / 100, size / 100);
      SHAPES[name](c);
      const data = c.getImageData(0, 0, sw, sh).data, m = new Float32Array(dots.length);
      let area = 0;
      for (let i = 0; i < dots.length; i++) {
        const x = Math.min(sw - 1, Math.floor(dots[i].x / k)), y = Math.min(sh - 1, Math.floor(dots[i].y / k));
        m[i] = data[(y * sw + x) * 4 + 3] / 255;
        if (m[i] > 0.5) area++;
      }
      m.area = area / dots.length;                                       // share of LEDs inside the silhouette
      return m;
    };
    const shapeEnvelope = (time) => {
      if (cfg.shapes !== 'halloween' || reduceMotion || !dots.length) return 0;
      if (!shape && time >= nextShapeAt) shape = { m: makeShape(SHAPE_ORDER[shapeN++ % SHAPE_ORDER.length]), t0: time, dur: 7000 };
      if (!shape) return 0;
      const p = (time - shape.t0) / shape.dur;
      if (p >= 1) { shape = null; nextShapeAt = time + 2500 + Math.random() * 3000; return 0; }
      const up = Math.min(1, p / 0.28), down = Math.min(1, (1 - p) / 0.28);
      return smooth(up) * smooth(down);
    };

    const layout = () => {
      W = innerWidth; H = innerHeight;
      const small = W < 700;
      const dpr = Math.min(devicePixelRatio || 1, 1.5);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      gap = small ? 16 : 20;
      dots = [];
      for (let y = gap / 2; y < H; y += gap) for (let x = gap / 2; x < W; x += gap) dots.push({ x, y, r: Math.random(), ph: Math.random() * 6.283, s: 0.8 + Math.random() * 0.4, hi: Math.random() < 0.7 });
      vals = new Float32Array(dots.length); alpha = new Float32Array(dots.length);
      shape = null;
    };
    const smooth = (t) => t * t * (3 - 2 * t);
    const frame = (time) => {
      raf = 0;
      if (!cfg.enabled || document.hidden) return;
      if (lastT && time - lastT < minStep) { raf = requestAnimationFrame(frame); return; }
      const dt = lastT ? Math.min(64, time - lastT) / 16.67 : 1;
      lastT = time;
      sCur += (sTarget - sCur) * ease(0.1, dt);
      const dv = Math.abs(sCur - lastSc) / dt;
      lastSc = sCur;
      vel += (Math.min(dv, 120) - vel) * ease(dv > vel ? 0.25 : 0.03, dt);
      if (!reduceMotion) { phase += (0.001 + vel * 0.0014) * dt; zphase += (0.0016 + vel * 0.0008) * dt; }
      const moving = dv > 0.5;
      settle += ((moving ? 0 : 1) - settle) * ease(moving ? 0.18 : 0.03, dt);
      intro = Math.min(1, intro + 0.015 * dt);
      const lo = cfg.min / 100, hiLit = cfg.max / 100;
      const lit = (lo + (hiLit - lo) * smooth(Math.min(1, sCur / (H * 1.2)))) * intro;
      const f = 1 / 300;
      const env = shapeEnvelope(time), sm = env > 0.01 && shape ? shape.m : null;
      // while a silhouette shows, light exactly enough LEDs to draw it (more at the top of the page, fewer further down
      // where the drift is busier), so the shape stays readable anywhere on the page, also while scrolling
      const litNow = sm ? lit * (1 - env) + Math.max(0.12, Math.min(0.6, sm.area * 1.15)) * env : lit;
      hist.fill(0);
      for (let i = 0; i < dots.length; i++) {
        const d = dots[i];
        const n = noise(d.x * f, d.y * f + phase, zphase) * 0.65 + noise(d.x * f * 2.3 + 17, d.y * f * 2.3 - phase * 1.7, zphase * 1.4 + 5) * 0.35;
        let v = n * 0.85 + d.r * 0.15;
        if (sm) v = Math.min(0.999, v * (1 - 0.7 * env) + sm[i] * env * 0.9);   // inside the silhouette up, the rest dims a little
        vals[i] = v; hist[Math.min(127, Math.floor(v * 128))]++;
      }
      const need = Math.round(dots.length * litNow);
      let acc = 0, thr = 1;
      for (let b = 127; b >= 0; b--) { acc += hist[b]; if (acc >= need) { thr = b / 128; break; } }
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, W, H);
      const bl = ctx.createRadialGradient(W * 0.6, H * 0.45, 0, W * 0.6, H * 0.45, Math.max(W, H) * 0.8);
      bl.addColorStop(0, `rgba(${RGB[0]},${RGB[1]},${RGB[2]},${(0.02 + 0.09 * lit).toFixed(3)})`);
      bl.addColorStop(1, `rgba(${RGB[0]},${RGB[1]},${RGB[2]},0)`);
      ctx.fillStyle = bl; ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = 'rgba(255,255,255,0.045)';
      for (const d of dots) ctx.fillRect(d.x - 0.5, d.y - 0.5, 1, 1);
      ctx.globalCompositeOperation = 'lighter';
      const sz0 = gap * 1.45, glow = cfg.glow / 100, fa = ease(0.2, dt);
      for (let i = 0; i < dots.length; i++) {
        const d = dots[i];
        let a = (vals[i] - thr) / 0.035 + 0.5;
        a = a < 0 ? 0 : a > 1 ? 1 : a;
        alpha[i] += (a - alpha[i]) * fa;
        let k = alpha[i];
        if (k < 0.02) continue;
        if (!reduceMotion) k *= 0.82 + 0.18 * Math.sin(time * 0.0012 + d.ph);
        const hi = d.hi ? settle * glow : 0;          // LEDs that power up when scrolling stops
        const sz = sz0 * d.s * (1 + 0.36 * hi);
        if (hi > 0.05) {
          const hs = sz * 2.2;
          ctx.globalAlpha = k * 0.4 * hi;
          ctx.drawImage(sprite, d.x - hs / 2, d.y - hs / 2, hs, hs);
        }
        ctx.globalAlpha = Math.min(1, k * (0.58 + 0.76 * hi));
        ctx.drawImage(sprite, d.x - sz / 2, d.y - sz / 2, sz, sz);
      }
      still = moving ? 0 : still + 1;
      if (reduceMotion && intro >= 1 && still > 90) return;
      raf = requestAnimationFrame(frame);
    };
    const start = () => { if (!raf && cfg.enabled) { lastT = 0; raf = requestAnimationFrame(frame); } };
    const configure = () => {
      const node = $('[data-lp-leds-config]');
      if (node) { try { cfg = { ...cfg, ...JSON.parse(node.textContent) }; } catch (e) { /* keep defaults */ } }
      if (Array.isArray(cfg.color) && cfg.color.length === 3) { RGB = cfg.color.map(Number); paintSprite(); }
      cv.hidden = !cfg.enabled;
      start();
    };
    layout();
    addEventListener('scroll', () => { sTarget = scrollY; if (reduceMotion) start(); }, { passive: true });
    addEventListener('resize', () => { layout(); start(); });
    document.addEventListener('visibilitychange', start);
    if (document.readyState === 'complete') configure(); else addEventListener('load', configure, { once: true });
    return { configure };
  })();

  /* ---------- Product details window (quick view): the visitor never leaves the landing ---------- */
  let qv = null;
  // Automatic discount shown on the card (data-lp-pct): the window shows the same reduced price, old price struck.
  const lei = (cents) => {
    const v = Math.round(cents) / 100, int = Math.floor(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const dec = Math.round((v - Math.floor(v)) * 100);
    return int + (dec ? ',' + String(dec).padStart(2, '0') : '') + ' lei';
  };
  const qvPrice = (cents) => {
    const pr = qv.querySelector('[data-lp-qv-price]'), pct = Number(qv.dataset.pct || 0);
    if (!pr || !pct || !cents) return false;
    pr.textContent = lei(Math.floor(cents * (100 - pct) / 100));
    let old = pr.parentNode.querySelector('s');
    if (!old) { old = document.createElement('s'); pr.after(old); }
    old.textContent = lei(cents);
    return true;
  };
  const quickView = async (url, pct) => {
    if (!qv) {
      qv = document.createElement('dialog');
      qv.className = 'lp-qv';
      qv.setAttribute('aria-label', 'Detalii produs');
      qv.innerHTML = '<button type="button" class="lp-qv__x" aria-label="Închide">×</button><div class="lp-qv__body" data-lp-qv-body></div>';
      document.body.appendChild(qv);
      qv.addEventListener('click', (e) => {
        if (e.target === qv || e.target.closest('.lp-qv__x')) qv.close();
        const sw = e.target.closest('[data-lp-qv-sw]');
        if (sw && !sw.disabled) {
          qv.querySelectorAll('[data-lp-qv-sw]').forEach((b) => b.setAttribute('aria-checked', String(b === sw)));
          const id = qv.querySelector('[data-lp-qv-id]'), pr = qv.querySelector('[data-lp-qv-price]'), img = qv.querySelector('.lp-qv__img');
          if (id) id.value = sw.dataset.lpQvSw;
          if (pr && !qvPrice(Number(sw.dataset.cents)) && sw.dataset.price) pr.textContent = sw.dataset.price;
          if (img && sw.dataset.img) { img.removeAttribute('srcset'); img.src = sw.dataset.img; }
          qv.querySelectorAll('[data-lp-qv-thumb]').forEach((b) => b.classList.toggle('is-on', !!sw.dataset.img && b.dataset.lpQvThumb.split('?')[0] === sw.dataset.img.split('?')[0]));
        }
        const th = e.target.closest('[data-lp-qv-thumb]');
        if (th) {
          const img = qv.querySelector('.lp-qv__img');
          if (img) { img.removeAttribute('srcset'); img.src = th.dataset.lpQvThumb; }
          qv.querySelectorAll('[data-lp-qv-thumb]').forEach((b) => b.classList.toggle('is-on', b === th));
        }
      });
      qv.addEventListener('change', (e) => {
        if (!e.target.matches('[data-lp-qv-variant]')) return;
        const o = e.target.selectedOptions[0], pr = qv.querySelector('[data-lp-qv-price]');
        if (o && pr) pr.textContent = o.dataset.price;
      });
      qv.addEventListener('submit', () => qv.close(), true);   // the landing cart takes over (opens the cart drawer)
      qv.addEventListener('close', () => document.documentElement.classList.remove('lp-qv-open'));
    }
    qv.dataset.pct = pct || '';
    const body = qv.querySelector('[data-lp-qv-body]');
    body.innerHTML = '<p class="lp-qv__loading">Se încarcă…</p>';
    document.documentElement.classList.add('lp-qv-open');
    if (!qv.open) qv.showModal();
    try {
      const u = new URL(url, location.origin);
      u.search = ''; u.searchParams.set('section_id', 'csl-lp-quickview');
      const r = await fetch(u);
      if (!r.ok) throw new Error(r.status);
      body.innerHTML = await r.text();
      const pr = body.querySelector('[data-lp-qv-price]');
      if (pr && !(pr.parentNode.querySelector('s'))) qvPrice(Number(pr.dataset.cents));
    } catch (err) {
      body.innerHTML = '<p class="lp-qv__loading">Nu am putut încărca detaliile. Încearcă din nou.</p>';
    }
  };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-lp-quick]');
    if (!t || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    if (qv && qv.open && t.closest('.lp-qv')) return;
    const drawer = t.closest('[data-lp-cart], .lp-drawer');
    if (drawer && typeof closeCart === 'function') closeCart();
    const tag = t.closest('[data-lp-pct]');
    quickView(t.getAttribute('href'), tag ? tag.dataset.lpPct : '');
  });

  /* ---------- Init + theme editor ---------- */
  initReveal();
  initCountdown();
  initFilters();
  document.addEventListener('shopify:section:load', (e) => {
    initReveal(e.target);
    initFilters(e.target);
    initCountdown();
    if (leds) leds.configure();
    $$('.lp-rv', e.target).forEach((el) => el.classList.add('is-in'));
  });
  document.addEventListener('shopify:section:select', (e) => {
    $$('.lp-rv', e.target).forEach((el) => el.classList.add('is-in'));
    if (e.target.querySelector('[data-lp-cart]')) openCart();
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.querySelector('[data-lp-cart]')) closeCart();
  });
})();
